// key is local: every unsaved row has id 0, so it cannot key a chip.
export type ComplaintEntry = {
  key: string
  id: number
  complaint: string
}

// What the save flow reads from the field.
export type ComplaintListSnapshot = {
  rows: { id: number; complaint: string }[]
  dirty: boolean
  frozen: boolean
}

export const EMPTY_COMPLAINT_SNAPSHOT: ComplaintListSnapshot = {
  rows: [],
  dirty: false,
  frozen: false,
}
